module.exports = __webpack_public_path__ + "static/OB_Wuerzner_by_Salar_Baygan2-3c6076b05c7909a9fdba5653a08ef45f.jpg";